const cvData = {
  personalInfo: { name: 'Doge Bro' },
  education: {
    university: 'School of Hard Knocks',
    degree: 'PhD in Bro Science',
    selfTaught: 'Nutrition, weightlifting, pharmaceutical science, finance',
  },
  projects: [
    {
      name: 'Supplement Stack',
      url: '',
      repo: '',
      description: 'Creatine, taurine, L-Carnitine, NAC',
      category: 'Full Stack',
    },
    {
      name: 'Fin bro maxxing',
      url: 'https://nimbletrader.substack.com/',
      repo: 'https://nimbletrader.substack.com/',
      description: 'know your sharpe ratio',
      category: 'Finance',
    },
  ],
}

export default cvData
